import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { As400SyncStatus, type GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletAs400SyncStatusCellProps {
  pallet: GoodsReceiptPallet
}

const VISIBLE_SYNC_STATUSES: As400SyncStatus[] = [
  As400SyncStatus.Creating,
  As400SyncStatus.ReceivingDeleting,
  As400SyncStatus.WorkOrderDeleting,
  As400SyncStatus.DeletionFailed,
]

const SYNC_STATUS_TO_LABEL: Partial<Record<As400SyncStatus, string>> = {
  [As400SyncStatus.Creating]: "Create in progress",
  [As400SyncStatus.ReceivingDeleting]: "Delete in progress",
  [As400SyncStatus.WorkOrderDeleting]: "Delete in progress",
  [As400SyncStatus.DeletionFailed]: "Delete failed",
} as const

const SYNC_STATUS_TO_CLASS_NAME: Partial<Record<As400SyncStatus, string>> = {
  [As400SyncStatus.Creating]: "bg-tertiary-yellow-100",
  [As400SyncStatus.ReceivingDeleting]: "bg-tertiary-yellow-100",
  [As400SyncStatus.WorkOrderDeleting]: "bg-tertiary-yellow-100",
  [As400SyncStatus.DeletionFailed]: "bg-secondary-200",
} as const

export const GoodsReceiptPalletAs400SyncStatusCell: FC<GoodsReceiptPalletAs400SyncStatusCellProps> = ({ pallet }) => {
  if (!pallet.as400SyncStatus || !VISIBLE_SYNC_STATUSES.includes(pallet.as400SyncStatus)) {
    return null
  }

  return (
    <Chip
      className={twMerge("h-6 rounded-sm text-xs", SYNC_STATUS_TO_CLASS_NAME[pallet.as400SyncStatus])}
      label={SYNC_STATUS_TO_LABEL[pallet.as400SyncStatus]}
    />
  )
}
